<template lang="pug">
.row
  .col-12.mb-3
    .search-wrapper
      .search-input
        input.form-control(
          :placeholder='$t("integrations.searchPlaceholder")'
          type='text'
          v-model='search'
        )
        .input-icon
          Icon(name='magnifying-glass')
      button.sort-button(@click='toggleSort' type='button')
        Icon(
          :key='sortAsc'
          :name='sortAsc ? "arrow-up-a-z" : "arrow-down-z-a"'
        )

  .d-flex.flex-wrap.align-items-stretch.justify-content-start
    .card-wrapper(
      :key='integration.id'
      v-for='integration in filteredIntegrations'
    )
      IntegrationCard(
        :integration='integration'
        @configure='onConfigure(integration)'
      )

  IntegrationConfigureModal(
    :integration='selectedIntegration'
    @saved='handleSaved'
    ref='configureModal'
    v-if='selectedIntegration'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import alert from '@/modules/account/common/alert';
import IntegrationCard from '@/modules/account/components/organisms/card-table/IntegrationCard.vue';
import IntegrationConfigureModal from '@/modules/account/components/organisms/modals/IntegrationConfigureModal.vue';
import IntegrationsService from '@/services/IntegrationsService';

export default {
  name: 'IntegrationsAllTools',
  components: { Icon, IntegrationCard, IntegrationConfigureModal },
  data() {
    return {
      search: '',
      sortAsc: true,
      integrations: [],
      selectedIntegration: null,
    };
  },
  computed: {
    sortedIntegrations() {
      return [...this.integrations].sort((a, b) =>
        this.sortAsc
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name)
      );
    },
    filteredIntegrations() {
      const term = this.search.toLowerCase();
      return this.sortedIntegrations.filter((i) =>
        i.name.toLowerCase().includes(term)
      );
    },
  },
  methods: {
    async fetchIntegrations() {
      try {
        const resp = await IntegrationsService.listAll();
        this.integrations = Array.isArray(resp.data)
          ? resp.data.map((item) => ({
              id: item.value,
              name: item.label,
              description: item.description,
              logo: item.icon,
              type: item.value,
              config: item.config || {},
              is_active: item.is_active,
            }))
          : [];
      } catch (err) {
        console.error(this.$t('integrations.errorFetchingIntegrations'), err);
        this.integrations = [];
      }
    },
    onConfigure(integration) {
      this.selectedIntegration = integration;
      this.$nextTick(() => this.$refs.configureModal.open());
    },
    handleSaved({ name }) {
      this.fetchIntegrations();
      this.selectedIntegration = null;

      alert.fireAlert(
        this.$t('integrations.integrationConfiguredSuccess', { name }),
        {
          classes: 'alert-success',
          styles:
            'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
          icon: 'circle-check',
        }
      );
    },
    toggleSort() {
      this.sortAsc = !this.sortAsc;
    },
  },
  created() {
    this.$store.dispatch('page/setClass', 'account integrations');
    this.$store.dispatch('page/setTitle', this.$t('nav.admin.integrations'));
    this.$store.dispatch('page/setHead', this.$t('nav.admin.integrations'));
    this.fetchIntegrations();
  },
};
</script>

<style scoped>
.search-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 358px;
  margin-bottom: 16px;
}
.search-input {
  position: relative;
  flex: 1;
}
.search-input .form-control {
  width: 100%;
  padding-right: 2.5rem;
  border-radius: 8px;
  border: 1px solid #ced4da;
  height: 38px;
}
.input-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #495057;
  pointer-events: none;
}
.sort-button {
  border: none;
  background: transparent;
  font-size: 1.25rem;
  color: #495057;
  cursor: pointer;
}
.card-wrapper {
  width: 316px;
  margin: 8px;
}
@media (max-width: 992px) {
  .search-wrapper {
    padding-left: 10px;
  }
}
</style>
